import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
function SearchDonationCardSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-120 w-160 shrink-0 rounded-medium mobile-tablet:h-90 mobile-tablet:w-120" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full flex-col gap-2"><div className="flex w-full items-center justify-between gap-8"><Skeleton className="h-16 w-80 rounded-xxsmall" /><Skeleton className="h-16 w-60 rounded-xxsmall" /></div><Skeleton className="h-20 w-full rounded-xxsmall" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-4 w-full rounded-pill" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div role="status" aria-label={"\uC9C0\uC815\uAE30\uBD80\uC0AC\uC5C5 \uB85C\uB529 \uC911"} className="flex w-full items-center gap-20 mobile-tablet:gap-14">{t0}<div className="flex min-w-0 flex-1 flex-col justify-center gap-12 mobile-tablet:gap-8">{t1}<div className="flex w-full flex-col gap-4 mobile-tablet:gap-2">{t2}<div className="flex w-full items-center justify-between gap-4"><Skeleton className="h-16 w-120 rounded-xxsmall" /><Skeleton className="h-16 w-32 rounded-xxsmall" /></div></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
interface SearchDonationSkeletonListProps {
  count: number;
  className?: string;
}
export function SearchDonationSkeletonList(t0) {
  const $ = _c(5);
  const {
    count,
    className
  } = t0;
  const t1 = className ?? "flex flex-col gap-20 mobile-tablet:gap-16 mobile-tablet:px-20";
  let t2;
  if ($[0] !== count) {
    t2 = Array.from({
      length: count
    }, _temp);
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <ul aria-busy="true" className={t1}>{t2}</ul>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(_, index) {
  return <li key={index}><SearchDonationCardSkeleton /></li>;
}